<template>
	<main>
		<div class="container">
			<div class="title-container">
				<h2>Nos prestations</h2>
				<p>Découvrez nos services sur-mesure</p>
			</div>

			<section>
				<article>
					<div class="title">
						<h3>Visite guidée</h3>
						<h4>Partez à la découverte de l’ostréiculture</h4>
					</div>
					<p>
					En couple, entre amis ou avec les enfants, passez un agréable moment dans notre cabane ostréicole.
					Avec plus de 1h00, nos visites séduiront les amoureux des huîtres, comme les plus craintifs, les plus curieux comme les novices !<br><br>
					À la fin de votre visite découvrez nos huîtres avec des accompagnements raffinés selon vos envies !<br>
					Une sélection de six huîtres avec citron, beurre de sélection et verre de vin blanc vous attend.
					Nos guides vous initieront également à l’ouverture des huîtres.<br><br>
					Envie de pique-niquer ?
					Repartez avec nos paniers-repas à déguster au bord de la digue.<br><br>
					Nos visites sont disponibles uniquement sur réservation.
					Réservez votre visite au <b>06 32 45 01 97</b>.
					</p>
				</article>

				<div class="array">
					<img src="@/assets/about/services/tableau.png" alt="Tableau des horaires et tarifs des visites.">
				</div>

				<ImageSlider :imagesUrl="imagesUrl" />

				<article class="roulotte">
					<div class="title">
						<h3>La roulotte iodée </h3>
						<h4>Un bar à huîtres pour vos événements</h4>
					</div>

					<div class="roulotte__wrapper">
						<div class="img-wrapper">
							<img src="@/assets/about/services/roulotte_iode.png" alt="Camion 'La roulotte iodée'">
						</div>

						<aside>
							<p>Notre “Roulotte iodée”, notre bar à huîtres ambulant, a été conçue pour vous accompagner dans vos instants festifs qu’ils soient privés ou professionnels. <br><br>
								Nous nous déplaçons sur place et mettons en oeuvre notre savoir-faire et notre convivialité pour animer vos événements de façon original.
								La “Roulotte iodée” vous propose une animation traiteur autour de la mer, parfaite pour les fins gourmets et idéal pour les initiés. <br><br>
								La volonté de notre équipe est de vous satisfaire et de vous accompagner dans la durée.
								Échangeons autour de votre projet, nous sommes disponibles et à votre écoute pour créer une prestation à vos mesures et selon vos envies.
							</p>
              <router-link :to="{name: 'ContactUs'}" class="button full">Demander un devis</router-link>
						</aside>

					</div>
				</article>
			</section>
		</div>
	</main>
</template>

<script>
import {mapActions, mapGetters} from "vuex";

const ImageSlider = () => import ("@/components/ImageSlider.vue")

export default {
	name: "Services",
  beforeMount () {
    this.$store.dispatch('metaData/getMetaData', 18)
  },
  computed: {
    ...mapGetters('metaData', ['getMeta']),
  },
  metaInfo() {
    return {
      title: this.getMeta.template,
      meta:[
        // meta données générales
        {  name: 'title', content: this.getMeta.meta_title},
        { name: 'description', content: this.getMeta.meta_desc},
        { name: 'robots', content: 'index,follow'},
        // pour SEO FB et Linkedin
        { property: 'og:type', content:"website"},
        { property: 'og:url', content: "https://lafamilleboutrais.com/"},
        { property: 'og:title', content: this.getMeta.meta_title},
        { property: 'og:description', content: this.getMeta.meta_desc},
        // { property: 'og:image', content: this.getCategory.image },
      ],
    }
  },
	components: {ImageSlider},
	data() {
		return {
			imagesUrl: [
				require('@/assets/about/services/a-propos-prestations-1.png'),
        require('@/assets/about/services/a-propos-prestations-2.png'),
        require('@/assets/about/services/a-propos-prestations-3.png'),
			]
		}
	},
  methods: {
    ...mapActions('metaData', ['getMetaData']),
  },
}
</script>

<style lang="scss" scoped>
.container {
	@include flex(flex-start, flex-start, column, $gap: 20px);
	position: relative;
	width: 90vw;
	max-width: 1200px;
	margin: 0 auto;
	@media screen and (min-width: 992px) {
		width: 90vw;
	}
	@media screen and (min-width: 1200px) {
		width: 80vw;
	}
}

.title-container {
	width: 100%;
	text-align: center;
	margin: 50px 0 45px;

	@media screen and (min-width: 992px) {
		margin: 50px 0 75px;
	}

	h2 {
		color: $LightBrown;
		font-size: 35px;

		@media screen and (min-width: 768px) {
			font-size: 45px;
		}

		@media screen and (min-width: 992px) {
			font-size: 56px;
		}
	}
}

section {

	article .title {
		margin-bottom: 15px;

		h4 {
			font-weight: 600;
		}
	}

	.array {
		@include flex(center, center);
		width: 100%;
		height: auto;
		object-fit: contain;
		margin: 75px auto;
	}

	.roulotte {
		margin-top: 75px;

		&__wrapper {
			@include flex(center, center,column, $gap: 50px);
			@media screen and (min-width: 992px) {
				flex-direction: row;
			}

			.img-wrapper {
				@include flex(center, center);
				flex: 1;
			}

			aside {
				flex: 1;
				font-size: 14px;


				a {
					width: fit-content;
					margin: 20px auto;
				}
			}
		}



	}
}

</style>